import { createContext } from "react";

const ShoppingCartProductContext = createContext();

export default ShoppingCartProductContext;
